module.exports = __webpack_public_path__ + "img/legume-shell-beans-190x100.0a5a36fe.jpg";